import Calculator from './components/Calculator';
import './styles/App.css';

function App() {
  return (
    <div className="app-wrapper">
      <Calculator />
    </div>
  );
}

export default App;